import { IPortalAcesso } from '../interfaces/portal';

/** The one screen a brand buyer reaches. */
export const PORTAL_PATH = '/portal';

/**
 * Who the shell is serving, from the answer of `GET /portal/acesso`:
 * - `pending`: the answer has not arrived, so neither the menu nor a screen is drawn yet;
 * - `failed`: it did not arrive, and the shell says so with a retry;
 * - `brandBuyer`: only the Portal, only of the buyer's brands (the server refuses the rest);
 * - `staff`: the factory, every screen.
 */
export type TSessionAudience = 'pending' | 'failed' | 'brandBuyer' | 'staff';

export function sessionAudience(acesso: IPortalAcesso | null, failed: boolean): TSessionAudience {
  if (acesso !== null) {
    return acesso.clienteDaMarca ? 'brandBuyer' : 'staff';
  }
  return failed ? 'failed' : 'pending';
}

/**
 * Whether a route is the Portal. Matches on a separator, so a route of a similar name never
 * passes for it (`/portalzinho` is not `/portal`).
 */
export function isPortalRoute(pathname: string): boolean {
  const caminho = (pathname.split('?')[0] ?? '').replace(/\/+$/, '');
  return caminho === PORTAL_PATH || caminho.startsWith(`${PORTAL_PATH}/`);
}
